import { z } from 'zod';
import { ENVIRONMENTS } from '~/constants';

import { RELEASE_NOTES_APPS, VERSION_COMPARATORS } from './constants';

/**
 * Zod schema for the query parameters for the release notes query.
 */
export const zodReleaseNotesQueryParamsSchema = z.object({
  app: z
    .enum(RELEASE_NOTES_APPS)
    .optional()
    .prefault('customer-portal')
    .catch('customer-portal'),
  comparator: z.enum(VERSION_COMPARATORS).optional().catch(undefined),
  environment: z
    .enum(ENVIRONMENTS)
    .transform((value) => (value === 'staging' ? 'production' : value))
    .optional()
    .prefault('production')
    .catch('production'),
  language: z.enum(['de', 'en']).optional().prefault('de').catch('de'),
  version: z.string().optional(),
});
